import { Button, Card } from "@prisma/ui";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { PageHeader } from "../../components/PageHeader";
import { QueryState } from "../../components/QueryState";
import { formatRelative, secondsSince } from "../../lib/format";
import { notificationKey, notificationLink, useMarkRead, useNotifications } from "./useNotifications";

export function NotificationsPage() {
  const { t, i18n } = useTranslation();
  const q = useNotifications();
  const { one, all } = useMarkRead();
  return (
    <div className="space-y-6">
      <PageHeader titleKey="notification.title"
        actions={(q.data?.unread ?? 0) > 0 ? <Button onClick={() => all.mutate()}>{t("notification.mark_all_read")}</Button> : undefined} />
      <QueryState query={q}>
        {(d) => d.items.length === 0 ? (
          <Card className="p-8 text-center text-[14px] text-ink-2">{t("notification.empty")}</Card>
        ) : (
          <Card className="divide-y divide-[var(--border-default)]">
            {d.items.map((n) => {
              const to = notificationLink(n);
              const label = t(notificationKey(n), { ...n.params });
              return (
                <div key={n.id} className="flex items-center gap-3 px-5 py-4">
                  <span aria-hidden="true" className={`size-2 shrink-0 rounded-full ${n.read_at ? "bg-transparent" : "bg-[var(--accent-primary)]"}`} />
                  <div className="min-w-0 flex-1">
                    {to ? (
                      <Link to={to} onClick={() => !n.read_at && one.mutate(n.id)} className={`hover:underline ${n.read_at ? "text-ink-2" : "font-medium text-ink"}`}>{label}</Link>
                    ) : (
                      <span className={n.read_at ? "text-ink-2" : "text-ink"}>{label}</span>
                    )}
                  </div>
                  {n.created_at && <span className="shrink-0 text-[12px] text-ink-2">{formatRelative(secondsSince(n.created_at), i18n.language)}</span>}
                </div>
              );
            })}
          </Card>
        )}
      </QueryState>
    </div>
  );
}
